var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',[_c('v-container',[_c(_vm.selectEditor(_vm.$route.params.viewmode, _vm.$route.params.workview),{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }